import { togglePhotoTextZoneButtons, togglePhotoTextZoneResetButton } from '../../../utils/photo-text-zone-utils';

type ValidatePhotoTextZoneHasContentProps = {
  canvas: fabric.Canvas;
  photoTextZone: fabric.Group;
  textBox: fabric.Textbox;
};

export const validatePhotoTextZoneHasContent = ({
  canvas,
  photoTextZone,
  textBox,
}: ValidatePhotoTextZoneHasContentProps): void => {
  if (textBox.text === '') {
    photoTextZone.data.hasContent = false;
    togglePhotoTextZoneButtons(true, canvas, photoTextZone);
    togglePhotoTextZoneResetButton(false, canvas, photoTextZone);
    canvas.renderAll();
  } else {
    photoTextZone.data.hasContent = true;
  }
};
